module.exports = `${require.publicPath}icon03.92231430.png`;